// This file is generated by a script and should not be modified directly.
const markdown: string =
  "Code(s) ROME pour le champ de recherche\n\nLe ROME correspond à la référence opérationnelle pour les métiers et les emplois conçue par France Travail.\n\nListe des codes séparés par des virgules\n\nLes codes doivent respecter les formats ROME\n"
export default markdown
